var jade = require("D:\\Git\\projection-grid\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (cancelButtonText, saveButtonText, value) {
buf.push("<form role=\"dialog\" class=\"form-inline grid-popup-editor\"><input type=\"text\"" + (jade.attr("value", value, true, true)) + " class=\"form-control editor\">&nbsp<button type=\"button\" class=\"btn btn-primary save\">" + (jade.escape(null == (jade_interp = saveButtonText) ? "" : jade_interp)) + "</button>&nbsp<button type=\"button\" class=\"btn btn-default cancel\">" + (jade.escape(null == (jade_interp = cancelButtonText) ? "" : jade_interp)) + "</button></form>");}.call(this,"cancelButtonText" in locals_for_with?locals_for_with.cancelButtonText:typeof cancelButtonText!=="undefined"?cancelButtonText:undefined,"saveButtonText" in locals_for_with?locals_for_with.saveButtonText:typeof saveButtonText!=="undefined"?saveButtonText:undefined,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./js/popup-editor/index.jade
// module id = 34
// module chunks = 0